<template> 
<div class="pt620">
    <breadcrumb :navListCustom="[{title:'マイページ', routerName: SiteConstants.PG010MAIN, param: {pageNo: '81'}}, {title:$t('pt620.labels.title'), routerName: '', param: {}}]"></breadcrumb>
    <div class="section page-mypage mb32">
        <h2>{{$t('common.labels.titleHeaderOrder')}}</h2>
        <div class="section-inner">
            <h3>{{$t('pt620.labels.title')}}</h3>
            <message :listMess="listMessValid" :mapMsg="mapMessValid" :idScreen="'pt620'"/>
            <div id="warming">
                <p class="caution mb32"></p>
            </div>
                <div v-if="pageFeedData.totalRecord > 0">
                    <div class="tab clearfix">
                        <!-- 注文 -->
                        <a @click="pt620search(1)"><span>{{$t('pt620.labels.order')}}</span></a>
                        <!-- キャンセル注文 -->
                        <a @click="pt620search(3)"><span>{{$t('pt620.labels.cancel')}}</span></a>
                    </div>
                    <br>
                    <br>
                    <select v-model="reqModel.rirekiKbn" name="rirekiKbn" id="_rirekiKbnList" style="float:left;" @change="changeRirekiKbn(reqModel.rirekiKbn);">
                        <option v-for="(item, index) in pt620Init.rirekiKbnList" :key="index" :value="item.KEY" >
                            {{item.VALUE}}
                        </option>
                    </select>
                    <div style="float:left; padding-left:20px; padding-top:5px;">
                        <span v-if="reqModel.searchKbn == '1'">に確定された{{reqModel.totalRecord}}件の注文</span>
                        <span v-if="reqModel.searchKbn == '3'">にキャンセルされた{{reqModel.totalRecord}}件の注文</span>
                    </div>
                    <br>
                    <br>
                </div>
                <!-- 検索結果に一致する注文がない場合 -->
                <div v-if="noResult" class="section-inner mb16" >
                    <span class="text-danger">
                        <!-- 検索条件に一致する注文がありませんでした。 -->
                        {{$t('pt620.labels.messgNoResult')}}
                    </span>
                </div>
                <!-- ページャー表示 -->
                <div class="mb64 pt15">
                    <page-feed v-if="isDisplay"
                        :isDisplay="isPagingDisplay"
                        :isDisplaySort="false"
                        :pageFeedData="pageFeedData"
                        :orderByType="ptOrderByType"
                        :dispPageSizeList="dispPageSizeList"
                        @search="changeSearch"
                        >
                        <template slot="TableRender">
                            <div class="float-right">
                                <template v-if="isTuisekiLinkShow">
                                    <div v-if="pt620Init.tuisekiLinkUrl != '' && pt620Init.tuisekiLinkUrl != null">
                                        <a class="href-style" @click="selectTuisekiLink()">{{$t('pt620.labels.tuisekiLinkWord')}}</a>
                                    </div>
                                </template>
                            </div>
                            <table class="mb16" id="cart-history">
                                <thead>
                                    <!-- No. -->
                                    <th v-if="siteFlg == '1'" scope="col" class="w20">{{$t('pt620.labels.no')}}</th>
                                    <!-- No. -->
                                    <th scope="col" class="w20">{{$t('pt620.labels.no')}}</th>
                                    <!-- 届先 -->
                                    <th v-if="siteFlg == '1'" scope="col" class="w160">{{$t('pt620.labels.destination')}}</th>
                                    <!-- ご注文日 -->
                                    <th scope="col" class="w130">{{$t('pt620.labels.orderDate')}}</th>
                                    <!-- 注文番号 -->
                                    <th scope="col" class="w130">{{$t('pt620.labels.orderNo')}}</th>
                                    <!-- 注文番号 -->
                                    <th scope="col" class="w130">{{pt620Init.dispKokyakuCdNm}}</th>
                                    <!-- 注文者 -->
                                    <th scope="col" class="w130">{{$t('pt620.labels.kokyakuNm')}}</th>
                                    <!-- 配送先名 -->
                                    <th scope="col" class="w130">{{$t('pt620.labels.tdkNm')}}</th>
                                    <!-- 注文区分 -->
                                    <th v-if="pt620Init.orderKbnFlg == 1" scope="col" class="w130">{{$t('pt620.labels.orderKbn')}}</th>
                                    <!-- 金額 -->
                                    <template v-if="pt620Init.syouhiZeiDispFlg == 0">
                                        <th scope="col" class="w110">
                                            {{$t('pt460.labels.kingakuStr')}}
                                        </th>
                                    </template>
                                    <template v-else>
                                        <th scope="col" class="w110">
                                            {{$t('pt630.labels.kingakuStr')}}{{$t('pt620.labels.taxincluded')}}
                                        </th>
                                    </template>
                                    <!-- 支払い方法 -->
                                    <th scope="col" class="w130">{{$t('pt620.labels.payment')}}</th>
                                    <!-- お支払い -->
                                    <th scope="col" class="w100">{{$t('pt430.labels.pay')}}</th>
                                    <template v-if="pt620Init.syukkaKanriFlg == 0">
                                        <!-- 配送業者 -->
                                        <th scope="col"  class="w130">{{$t('pt620.labels.deliveryCompany')}}</th>
                                        <!-- 出荷日	 -->
                                        <th scope="col"  class="w130">{{$t('pt630.labels.shipDate')}}</th>
                                        <!-- お問い合わせ番号 -->
                                        <th scope="col" >{{$t('pt620.labels.optionLabel')}}</th>
                                    </template>
                                    <!-- 詳細 -->
                                    <th scope="col" class="w80">{{$t('pt620.labels.details')}}</th> 
                                </thead>
                                <tbody>
                                    <tr v-for="(orders, index) in pt620Init.list" :key="index">
                                        <td v-if="siteFlg == '1'" class="cart-num">
                                            <span v-if="orders.GIFT_KBN =='1'">{{$t('pt620.labels.directDelivery')}}</span>
                                        </td>
                                        <!-- No. -->
                                        <td class="cart-num" scope="row" aria-label="No.">
                                            {{pageFeedData.fromRecord+index}}
                                        </td>
                                        <!-- ご注文日 -->
                                        <td class="cart-num" :aria-label="$t('pt620.labels.orderDate')">
                                            <span>{{orders.ORDER_YMD}}</span>
                                        </td>
                                        <!-- 注文番号 -->
                                        <td class="cart-num" :aria-label="$t('pt620.labels.orderNo')">
                                            <span>{{orders.ORDER_CD_TYPICAL}}</span>
                                        </td>
                                        <!-- 顧客CD -->
                                        <td class="cart-num" aria-label="kokyakuCd.">
                                            <span>{{orders.KOKYAKU_CD}}</span>
                                        </td>
                                        <!-- 注文者 -->
                                        <td class="cart-num" :aria-label="$t('pt620.labels.kokyakuNm')">
                                            <span>{{orders.KOKYAKU_NM1}}</span>
                                        </td>
                                        <!-- 配送先名 -->
                                        <td class="cart-num" :aria-label="$t('pt620.labels.tdkNm')">
                                            <span>{{orders.KOKYAKU_NM1}}</span>
                                        </td>
                                        <!-- 注文区分 -->
                                        <td v-if="pt620Init.orderKbnFlg == 1" class="cart-num" :aria-label="$t('pt620.labels.orderKbn')">
                                            <span>{{orders.ORDER_KBN_NM}}</span>
                                        </td>
                                        <!-- 金額 -->
                                        <template v-if="pt620Init.syouhiZeiDispFlg == 0">
                                            <td class="cart-price" :aria-label="$t('pt620.labels.kingakuStr')">
                                                <input-number v-model="orders.SEIKYUU_ZEI_K_KIN" :readonly="true" :suffix ="'円'" />
                                            </td>                                            
                                        </template>
                                        <template v-else>
                                            <td class="cart-price" :aria-label="$t('pt620.labels.kingakuStrTax')">
                                                <input-number v-model="orders.SEIKYUU_ZEI_K_KIN" :readonly="true" :suffix ="'円'" />
                                            </td>
                                        </template>
                                        <!-- 支払い方法 -->
                                        <td class="cart-num" :aria-label="$t('pt620.labels.payment')">
                                            <span>{{orders.KESSAI_NM}}</span>
                                        </td>
                                        <!-- 支払い -->
                                        <td class="cart-num" :aria-label="$t('pt620.labels.pay')">
                                            <!--決済エラー-->
                                            <span v-if="orders.AUTH_NOT_FLG == '1' && orders.TEIKI_KBN == '1'">{{$t('pt620.labels.error')}}<br></span>
                                            <span v-else-if="orders.KESSAI_CD == '2' || orders.KESSAI_CD == '13' || orders.KESSAI_CD == '999'">{{$t('pt620.labels.hiphen')}}</span>
                                            <span v-else-if="orders.NYUKIN_K_FLG == '1'">{{$t('pt620.labels.paid')}}</span>
                                            <span v-else>{{$t('pt620.labels.check')}}</span>
                                            <span v-if="orders.AUTH_NOT_FLG == '1' && orders.TEIKI_KBN == '1'">{{$t('pt620.labels.selectPayment')}}</span>
                                            <button v-if="orders.AUTH_NOT_FLG == '1' && orders.TEIKI_KBN == '1'" type="button" class="btn-danger" @click="dochange(orders.ORDER_CD_TYPICAL)">{{$t('pt430.labels.change')}}</button>
                                        </td>
                                        <template v-if="pt620Init.syukkaKanriFlg == 0">
                                        <!-- 配送業者 -->
                                            <td :aria-label="$t('pt620.labels.deliveryCompany')">
                                                <span>{{orders.MARK_NM}}</span>
                                            </td>
                                            <td v-if="orders.ORDER_CNT != '1'" class="cart-price">
                                                <span>{{$t('pt620.labels.multiShipments')}}</span> <br> <span>{{$t('pt620.labels.confirmDetScreen')}}</span>
                                            </td>
                                            <!-- 出荷日	 -->
                                            <td v-else class="cart-num" :aria-label="$t('pt620.labels.shipDate')">
                                                <span v-if="orders.SYUKKA_YMD == null">&nbsp;</span>
                                                <span v-else>{{orders.SYUKKA_YMD}}</span>
                                            </td>
                                            <!-- お問い合わせ番号 -->
                                            <td class="cart-num" :aria-label="$t('pt620.labels.optionLabel')">
                                                <template v-if="isTuisekiLinkShow">
                                                    <a v-if=" orders.OKURINO_TYPICAL == null">&nbsp;</a>
                                                    <a v-else class="tuisekiLink" @click="selectTuisekiLinkUrl(orders.TRANS_CO_KBN,orders.OKURINO_TYPICAL)">{{orders.OKURINO_TYPICAL}}</a>
                                                </template>
                                                <template v-else>
                                                    <span>{{orders.OKURINO_TYPICAL}}</span>
                                                </template>
                                            </td>
                                        </template>
                                        <!-- 詳細 -->
                                        <td class="cart-link">
                                            <router-link :to="{ name: SiteConstants.PG010MAIN, query:{ pageNo:25, orderNo: orders.ORDER_NO,orderCdTypical: orders.ORDER_CD_TYPICAL, fBaFlg: orders.F_BA_FLG }, params: {orderNo: orders.ORDER_NO, orderCdTypical: orders.ORDER_CD_TYPICAL, fBaFlg: orders.F_BA_FLG, requestBack: reqModel}}">{{$t('pt620.labels.details')}}</router-link>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </template>
                    </page-feed>
                </div>
            </div>
        </div>
    </div>
</template>
<script>

/* 
* Import libs and componnents
*/
import common from "assets/js/common";
import axios from "assets/js/request";
import InputCheck from 'components/InputCheck';
import InputNumber from 'components/InputNumber';
import Message from 'components/MessageEcSite';
import PageFeed from '../commonParts/PageFeed';
import SiteConstants from 'assets/const/SiteConstants.json';
import Breadcrumb from "../commonParts/Breadcrumb.vue";
export default {
    /* 
    * Name of component
    */
    name: "PT620MemberOrderHisParts",
    /*
    * Declare props
    */
    props: {
        ptPageNo: {
            type: [Number,String]
        },
        ptPageSize: {
            type: [Number,String]
        },
        ptOrderByType: {
            type: [Number,String]
        },
        ptInitData: {
            type: Object,
            default: null,
        }
    },
    /*
    * Declare components
    */
    components:{
            InputCheck,
            InputNumber,
            Message,
            PageFeed,
            Breadcrumb
        },
    data() {
        return {
            isDisplay: false,
            noResult: false,
            rowIndex: null,
            isPagingDisplay:true,
            isLoading: false,
            siteFlg : null,
            isTuisekiLinkShow: false,
            reqModel:{
                totalRecord: null,
                fromRecord: null,
                toRecord: null,
                rirekiKbn:'0',
                searchKbn:'1',
                pageSize: this.ptPageSize != undefined ? this.ptPageSize : 15,
                pageNo: this.ptPageNo != undefined ? this.ptPageNo : 1
            },
            pt620Init: {},
            pageFeedData: {
                totalRecord: 50,
                fromRecord: 0,
                toRecord: 10,
                pageSize: 10,
                pageNo: 1
            },
            dispPageSizeList:[
                {value: 5,text: "5行"},
                {value: 15,text: "15行"},
                {value: 30,text: "30行"},
                {value: 45,text: "45行"},
                {value: 50,text: "50行"},
                {value: 100,text: "100行"}
            ],
            SiteConstants: SiteConstants,
            iSearch:false,
            // for validate
            listIdErr:[],
            listMessValid:[],
            mapMessValid:[],
            jptuisekiLink: null,
            site: "",
            tnkDspKbn: null
        }
    },
    mounted() {
        // Call API doInit
        var _this = this;
        _this.site = _this.$router.history.current.fullPath.split("/")[1];

        if (_this.ptInitData){
            if(_this.ptInitData.status == 'NG'){
                _this.$router.push({ name: _this.SiteConstants.PG010MAIN, query: {pageNo: 18}});
            }else {
                if (_this.iSearch==true){
                    _this.search();
                } else {
                    _this.pt620Init = _this.ptInitData;
                    _this.reqModel = Object.assign({}, _this.reqModel, _this.ptInitData.reqModels);
                    _this.search();
                }
            }
        }else{
            axios.get(_this.$UrlConstants.ECSITE + _this.$UrlConstants.PT620 + _this.$UrlConstants.DO_INIT, _this.reqModel).then(function(response) {
                if(response.data.status == 'NG'){
                    _this.$router.push({ name: _this.SiteConstants.PG010MAIN, query: {pageNo: 18}});
                }else {
                    if (_this.iSearch==true){
                        _this.search();
                    } else {
                        _this.pt620Init = response.data;
                        _this.reqModel = Object.assign({}, _this.reqModel, response.data.reqModels);
                        _this.search();
                    }
                }
            }).catch(function(error) {
                common.errorAPI(error);
            });
        }
    },

    methods: {
        //function Search
        search: function() {
            var _this = this;
            // Clear msg validate
            _this.listMessValid = [];
            _this.mapMessValid = [];
            common.clearMessageEcSite(_this.listIdErr,'pt620');
            _this.$emit("event-loading", true);
            axios.post(_this.$UrlConstants.ECSITE + _this.$UrlConstants.PT620 + _this.$UrlConstants.DO_SEARCH, _this.reqModel).then(function(response) {
                _this.pt620Init = response.data;
                if (response.data.list != null && response.data.list.length > 0) {
                    _this.pageFeedData.totalRecord = response.data.totalRecord;
                    _this.reqModel.totalRecord = response.data.totalRecord;
                    _this.pageFeedData.fromRecord = response.data.fromRecord;
                    _this.pageFeedData.toRecord = response.data.toRecord;
                    _this.pageFeedData.pageSize = response.data.pageSize;
                    _this.pageFeedData.pageNo = response.data.pageNo;
                    _this.tnkDspKbn = _this.pt620Init.list[0].TNK_DSP_KBN;
                     _this.isDisplay = true; 
                    _this.isPagingDisplay = true;
                    _this.noResult = false;
                    if(_this.pt620Init.tuisekiLinkFlg == 1){
                        _this.isTuisekiLinkShow = true;
                    }else{
                        _this.isTuisekiLinkShow = false;
                    }
                }else{
                    _this.isDisplay = false;
                    _this.noResult = true;
                    _this.reqModel.totalRecord = 0;
                }
                
                _this.$emit("event-loading", false);
            }).catch(function(error) {
                _this.isDisplay = false;
                _this.$emit("event-loading", false);
                if(error != null && error != undefined){
                    if(error.response != null && error.response != undefined){
                        if(406 == error.response.status){
                            var resultValid = common.excuteValidationEcSite(error,'pt620');
                            if(resultValid){
                                _this.listIdErr.push.apply(_this.listIdErr, resultValid.listIdErr);
                                _this.listMessValid = resultValid.msgList;
                                _this.mapMessValid = resultValid.mapMsg;
                            }
                        }else{
                            common.errorAPI(error);
                        }
                    }
                }
            });
        },
        changeRirekiKbn: function(Kbn) {
            var _this = this;
            _this.reqModel.rirekiKbn = Kbn;
            _this.search();
        },
        pt620search: function(skbn) {
            var _this = this;
            _this.reqModel.searchKbn = skbn;
            _this.search();
        },
        //Methods for pageFeed
        changeSearch: function(sortNo, pageSize, pageNo) {
            this.reqModel.pageSize = pageSize;
            this.reqModel.pageNo = pageNo;
            this.reqModel.orderByType = sortNo;
            var queryString = this.getQueryString(pageSize, 'ptPageSize');
            location.href = process.env.VUE_APP_PUBLIC_PATH + this.$route.path + '?' + queryString;
        },
        changePageSize: function(pageSize) {
            this.reqModel.pageSize = pageSize;
            var queryString = this.getQueryString(pageSize, 'ptPageSize');
            location.href = process.env.VUE_APP_PUBLIC_PATH + this.$route.path + '?' + queryString;
        },
        changePageNo: function(pageNo) {
            this.reqModel.pageNo = pageNo;
            var queryString = this.getQueryString(pageNo, 'ptPageNo');
            location.href = process.env.VUE_APP_PUBLIC_PATH + this.$route.path + '?' + queryString;
        },
        getQueryString: function(val, type){
            var query = this.$route.query;
            query.ptPageNo = this.reqModel.pageNo;
            query.ptPageSize = this.reqModel.pageSize;
            query.sKbn = this.reqModel.searchKbn;
            query.rKbn = this.reqModel.rirekiKbn;

            if(this.reqModel.orderByType != undefined) {
                query.ptOrderByType = this.reqModel.orderByType;
            }
            
            query[type] = val;

            var queryString = "";
            var index= 0;
            for(var propertyName in query) {
                if(index == 0){
                    queryString += propertyName + '=' + query[propertyName];
                } else{
                    queryString += '&' + propertyName + '=' + query[propertyName];
                }
                index++;
            }
            return queryString;
        },
        /* 
        * Function 
        * 追跡サイトへのリンク押下時処理
        */
        selectTuisekiLink: function(){
            //追跡サイトリンク
            window.open(this.pt620Init.tuisekiLinkUrl);
        },
        /* 
        * Function 
        * 追跡サイトへのリンク押下時処理
        */
        selectTuisekiLinkUrl: function(_transCoKbn,_okuriNo){
            if ('JP' == _transCoKbn) {
                var _jpLinkUrl = this.pt620Init.jptuisekiLink.replace('[1]',_okuriNo);
                window.open(_jpLinkUrl);
            } else if ('SG' == _transCoKbn) {
                var _sgLinkUrl = this.pt620Init.sgtuisekiLink.replace('[1]',_okuriNo);
                window.open(_sgLinkUrl);
            } else if ('YA' == _transCoKbn) {
                var _yaLinkUrl = this.pt620Init.yatuisekiLink.replace('[1]',_okuriNo);
                window.open(_yaLinkUrl);
            }
        }
    },

    /*
    * Excute code after an instance is created
    */
    created: function() {
        var _this = this;
        this.queryData = this.$route.query;
        if(this.queryData != null){
            if(this.queryData.sKbn != null){
                this.reqModel.searchKbn = this.queryData.sKbn;
            }
            if(this.queryData.rKbn != null){
                this.reqModel.rirekiKbn = this.queryData.rKbn;
            }
            if(this.queryData.ptPageNo != null){
                this.reqModel.pageNo = this.queryData.ptPageNo;
            }
            if(this.queryData.ptPageSize != null){
                this.reqModel.pageSize = this.queryData.ptPageSize;
            }
        }
        //Get param from router when contructor this.  
        var data = _this.$route.params;
        if (data.requestBack!=null){
            _this.reqModel = Object.assign({}, _this.reqModel, data.requestBack);
            _this.iSearch=true;
        }
    }
}
</script>
